import { FinancialSummaryPastDetail } from './FinancialSummaryPastDetail'
import { BalancePastDetailTable } from './BalancePastDetailTable'
import { CardContent, Card } from '@mui/material'

export const BalanceCompanyDetailPast = ({
  dataBalance,
  dataBalanceTransaction
}: {
  dataBalance: any
  dataBalanceTransaction: any
}) => {
  const checkHideDifferent =
    Number(dataBalance?.different?.total_actual_salary_reconcile) >
    Number(dataBalance?.different?.total_ewa_disbursement)

  return (
    <div className='flex flex-col gap-[26px]'>
      <FinancialSummaryPastDetail data={dataBalance} />
      <Card
        sx={{
          borderRadius: 3
        }}
      >
        <CardContent sx={{ padding: 0 }}>
          <BalancePastDetailTable
            data={dataBalanceTransaction?.data || []}
            meta={dataBalanceTransaction?.meta}
            checkHideDifferent={checkHideDifferent}
          />
        </CardContent>
      </Card>
    </div>
  )
}
